import React from 'react';
import { TextField } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
interface SearchPropes {
	searchTerm: string;
	setSearchTerm: (e: string) => void;
}
export default function MySearchInputs({ searchTerm, setSearchTerm }: SearchPropes) {
	return (
		<>
			<TextField
				variant="outlined"
				size="small"
				fullWidth
				placeholder="Search requests..."
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
				InputProps={{
					sx: { fontSize: { xs: 14, sm: 18 } },
					startAdornment: (
						<SearchIcon
							sx={{ color: 'action.active', mr: 1, fontSize: { xs: 18, sm: 20 } }}
						/>
					),
				}}
			/>
		</>
	);
}
